import { Component, ViewEncapsulation } from "@angular/core";
import { AvatarBase } from "./avatar-base";

@Component({
    selector: 'avatar[big]',
    styleUrls: ['./avatar.scss'],
    template: `
        <img *ngIf="shouldShowImage" [ngSrc]="imageUrl" width="32" height="32" (error)="onImageError()" (load)="imgLoaded()"/>
        <div class="st-avatar__initials" *ngIf="!shouldShowImage">{{initials}}</div>
        <ng-content select="[upload]"></ng-content>
	`,
    host: {
        'class': 'st-avatar'
    },
    // changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.None

})
export class AvatarBig extends AvatarBase {

}

@Component({
    selector: 'avatar[horizontal-big]:not([big])',
    styleUrls: ['./avatar.scss'],
    template: `
		<img *ngIf="shouldShowImage" [ngSrc]="imageUrl" width="32" height="32" (error)="onImageError()" (load)="imgLoaded()"/>
        <div class="st-avatar__initials" *ngIf="!shouldShowImage">{{initials}}</div>
		<div class="st-avatar__name" [matTooltip]="userName">{{userName}}</div>
        <ng-content select="[upload]"></ng-content>
    	`,
    host: {
        'class': 'st-avatar'
    },
    // changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.None

})
export class AvatarBigHorizontalName extends AvatarBase { }

@Component({
    selector: 'avatar[vertical-big]:not([big])',
    styleUrls: ['./avatar.scss'],
    template: `
		<img *ngIf="shouldShowImage" [ngSrc]="imageUrl" width="40" height="40" (error)="onImageError()" (load)="imgLoaded()"/>
        <div class="st-avatar__initials" *ngIf="!shouldShowImage">{{initials}}</div>
		<div class="st-avatar__name" [matTooltip]="userName">{{userName}}</div>
        <ng-content select="[upload]"></ng-content>
	`,
    host: {
        'class': 'st-avatar'
    },
    // changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.None

})
export class AvatarBigVerticalName extends AvatarBase { }
